import { SkeletonFormPage } from '@/features/_components/skeletons'
import { Container } from '@/features/_components/ui/container'
import { GuarantorHeaderSkeleton } from '../../_components/guarantor-header.skeleton'

export const GuarantorProfileSkeleton = () => {
  return (
    <Container className="h-full px-14 py-10 gap-6">
      <SkeletonFormPage
        header={<GuarantorHeaderSkeleton />}
        fieldGroups={[{ fields: 2 }, { fields: 2 }]}
      />
    </Container>
  )
}
